import { Plugins } from '@leverege/plugin';
export const WizardStepFactory = Plugins.createFactory('WizardStep', {
  strategy: Plugins.LOOKUP
});
export const WizardActionFactory = Plugins.createFactory('WizardAction', {
  strategy: Plugins.LOOKUP
});